import { useCallback, useEffect, useState } from "react";
import axios from "axios";

export const DOCTOR_UNREAD_MESSAGES_EVENT = "doctor-unread-messages-changed";

export const notifyDoctorUnreadMessagesChanged = () => {
  window.dispatchEvent(new Event(DOCTOR_UNREAD_MESSAGES_EVENT));
};

const initialSummary = {
  unreadMessages: 0,
  unreadPatients: 0,
};

export const useDoctorUnreadMessages = (
  doctorId,
  { pollInterval = 15000 } = {}
) => {
  const [summary, setSummary] = useState(initialSummary);
  const [loading, setLoading] = useState(false);

  const refreshUnreadMessages = useCallback(async () => {
    if (!doctorId) return initialSummary;

    try {
      setLoading(true);

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/doctor/unread-summary`,
        { doctorId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token") || null}`,
          },
        }
      );

      const nextSummary = {
        unreadMessages: Number(res.data?.unreadMessages || 0),
        unreadPatients: Number(res.data?.unreadPatients || 0),
      };

      setSummary(nextSummary);
      return nextSummary;
    } catch (error) {
      console.error("Failed to fetch unread messages", error);
      return initialSummary;
    } finally {
      setLoading(false);
    }
  }, [doctorId]);

  useEffect(() => {
    if (!doctorId) return undefined;

    refreshUnreadMessages();

    const handleUnreadChange = () => refreshUnreadMessages();
    const handleFocus = () => refreshUnreadMessages();
    const interval = setInterval(refreshUnreadMessages, pollInterval);

    window.addEventListener(DOCTOR_UNREAD_MESSAGES_EVENT, handleUnreadChange);
    window.addEventListener("focus", handleFocus);

    return () => {
      clearInterval(interval);
      window.removeEventListener(
        DOCTOR_UNREAD_MESSAGES_EVENT,
        handleUnreadChange
      );
      window.removeEventListener("focus", handleFocus);
    };
  }, [doctorId, pollInterval, refreshUnreadMessages]);

  return {
    ...summary,
    loading,
    refreshUnreadMessages,
  };
};
